<template>
  <div class="app-main-inner" style="background-color: #F5F7FA;height: 100%">
    <div class="app-main-inner-row">
      <div class="triggers">
        <template v-if="!isEdit">
          <el-button type="primary" :disabled="!oneDept.active" @click="toAdd">{{ $t('CargoMsg.Cargo_AddDept') }}</el-button>
          <el-button type="primary" :disabled="!oneDept.active" @click="toEdit">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
          <el-button v-if="!(oneDept.uuid===''||treeNode.hasChild)" type="danger" @click="toDel">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
          <el-button type="primary" :disabled="!oneDept.active" @click="toAddRole">{{ $t('CargoMsg.Cargo_AddRole') }}</el-button>
          <el-button v-show="$checkPermission(['button_ACPayAuth_departmentEnable'])" type="primary" :disabled="oneDept.active" @click="enableDepartment">{{ $t('CargoMsg.Cargo_Enable') }}</el-button>
          <el-button v-show="$checkPermission(['button_ACPayAuth_departmentDisable'])" type="danger" :disabled="!oneDept.active" @click="disableDepartment">{{ $t('CargoMsg.Cargo_Disable') }}</el-button>
        </template>
        <template v-else>
          <el-button type="primary" @click="toSave">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
          <el-button type="primary" @click="toCancelSave">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
        </template>
      </div>
    </div>
    <div class="section grid-wrapper" style="height: 40%;width: 100%">
      <el-form
        ref="form"
        label-width="100px"
        style="width: 100%; height: 100%; padding-left: 10px"
        label-position="left"
        :show-message="false"
      >
        <el-form label-width="100px" label-position="left">
          <el-row :gutter="10">
            <el-col :span="10">
              <div style="min-height:302px;">
                <el-form-item :label="$t('CargoMsg.Cargo_ChineseNamed')">
                  <el-input v-model="oneDept.chineseName" :disabled="!isEdit" style="width: 260px;" />
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_EnglishNamed')">
                  <el-input v-model="oneDept.englishName" :disabled="!isEdit" style="width: 260px;" />
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_DepartmentCode')">
                  <el-input v-model="oneDept.code" :disabled="!isEdit" style="width: 260px;" />
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_JobNumberCodeField')">
                  <el-input v-model="oneDept.jobNoPrefix" :disabled="!isEdit" style="width: 260px;" />
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_SettlementCompanyIsOrNot')">
                  <el-radio-group v-model="oneDept.clearing" :disabled="!isEdit">
                    <el-form-item style="width: 260px;">
                      <el-radio :label="false" style="float:left">{{ $t('CargoMsg.Cargo_No') }}</el-radio>
                      <el-radio :label="true" style="float:left">{{ $t('CargoMsg.Cargo_Yes') }}</el-radio>
                    </el-form-item>
                  </el-radio-group>
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_Introduction')">
                  <el-input v-model="oneDept.description" :disabled="!isEdit" type="textarea" rows="5" style="width: 260px;" />
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getDeptByUuid, delDeptByUuid, saveDept } from '@/api/department'
import { getLoading } from '@/utils/utilBaseElement'
import { syncSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'

export default {
  name: 'DeptTab',
  components: {

  },
  props: {
    sourceType: {
      type: String,
      default: 'clickTree' // 进入该页面的来源，点击树or officeTab过来的
    },
    treeNode: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      constant: {
        sourceType: {
          click: 'clickTree',
          office: 'officeTab'
        }
      },
      loading: false,
      isEdit: false,
      oneDept: {
        clearing: false
      },
      initOneDept: {
        acrossTenant: false,
        chineseName: '',
        clientRefCode: '',
        code: '',
        createdBy: 0,
        dateCreated: '',
        dateModified: '',
        departmentId: 0,
        description: '',
        dirty: false,
        englishName: '',
        active: 1,
        extendedData: '',
        jobNoPrefix: '',
        clearing: false,
        modifiedBy: 0,
        officeUuid: null,
        parentDepartmentUuid: null,
        tenantId: 0,
        uuid: '',
        version: 0
      }
    }
  },
  watch: {
    treeNode() {
      this.editHandler(false)
      if (this.sourceType === this.constant.sourceType.click) {
        this.fetchDept()
      }
    }
  },
  beforeMount() {
    this.oneDept = { ...this.initOneDept }
  },
  mounted() {
    if (this.sourceType === this.constant.sourceType.click) {
      this.fetchDept()
    }
    if (this.sourceType === this.constant.sourceType.office) {
      this.editHandler(true)
    }
  },
  methods: {
    fetchDept() {
      this.loading = getLoading()
      getDeptByUuid(this.treeNode.uuid).then(res => {
        this.oneDept = res.data
      }).finally((e) => {
        this.loading.close()
      })
    },
    toCheckForm() {
      let error = ''
      if (this.oneDept.chineseName.trim() === '' || this.oneDept.englishName.trim() === '') {
        error = this.$t('SystemMaintenance.TheOfTheDepartmentEmpty')
      }
      if (error) {
        this.$message.warning(error)
        return false
      }
      return true
    },
    toAdd() {
      this.editHandler(true)

      this.oneDept = { ...this.initOneDept }
    },
    toEdit() {
      this.editHandler(true)
    },
    toDel() {
      this.$confirm(this.$t('SystemMaintenance.AreYouWantToDelete3'), this.$t('SystemMaintenance.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        this.loading = getLoading()
        delDeptByUuid(this.oneDept.uuid).then(res => {
          let pUuid = this.oneDept.parentDepartmentUuid
          if (!pUuid) {
            pUuid = this.oneDept.officeUuid
          }
          this.$emit('refreshTree', pUuid)
        })
      }).finally(p => {
        this.loading.close()
      })
    },
    // 启用
    enableDepartment() {
      this.loading = getLoading()
      this.oneDept.active = true
      saveDept(this.oneDept).then(res => {
        this.$message.success(this.$t('SystemMaintenance.EnabledSuccessfully'))
        // 刷新缓存
        this.updateDeptData()
        this.$emit('refreshTree', res.data.uuid)
      }).finally((e) => {
        this.loading.close()
      })
    },
    // 禁用
    disableDepartment() {
      this.loading = getLoading()
      this.oneDept.active = false
      saveDept(this.oneDept).then(res => {
        this.$message.success(this.$t('SystemMaintenance.DisabledSuccessfully'))
        // 刷新缓存
        this.updateDeptData()
        this.$emit('refreshTree', res.data.uuid)
      }).finally((e) => {
        this.loading.close()
      })
    },
    toSave() {
      if (this.toCheckForm()) {
        if (this.sourceType === this.constant.sourceType.click) {
          if (!this.oneDept.uuid) {
            this.oneDept.parentDepartmentUuid = this.treeNode.uuid
            this.oneDept.officeUuid = this.treeNode.officeUuid
          }
        } else {
          this.oneDept.officeUuid = this.treeNode.uuid
        }
        this.loading = getLoading()
        if (this.oneDept.parentDepartmentUuid === '') {
          this.oneDept.parentDepartmentUuid = null
        }
        saveDept(this.oneDept).then(res => {
          this.$message.success(this.$t('Message.SaveSucceed'))
          if (this.oneDept.uuid) {
            // 编辑
            this.editHandler(false)
            this.fetchDept()
          } else {
            this.editHandler(false)
          }
          // 刷新缓存
          this.updateDeptData()
          this.$emit('refreshTree', res.data.uuid)
        }).finally((e) => {
          this.loading.close()
        })
      }
    },
    updateDeptData() {
      syncSpecificBasicData(basicCacheKeys.basic_data_Department)
      syncSpecificBasicData(basicCacheKeys.basic_data_Department_All)
    },
    toCancelSave() {
      if (this.sourceType === this.constant.sourceType.click) {
        this.editHandler(false)
        this.fetchDept()
      }
      if (this.sourceType === this.constant.sourceType.office) {
        this.$emit('cancel')
      }
    },
    toAddRole() {
      this.$emit('addRole', { type: 'dept', uuid: this.treeNode.uuid })
    },
    editHandler(edit) {
      this.isEdit = edit
      this.$emit('editData', this.isEdit)
    }
  }
}
</script>

<style scoped>

</style>
